var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagemail = function SvgTagemail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.996 8.999 3.083 2.377a3.001 3.001 0 0 0 3.602.046L17.001 9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 20.003H7.998a5.002 5.002 0 0 1-5.002-5.002V9a5.002 5.002 0 0 1 5.002-5.002h8.003a5.002 5.002 0 0 1 5.003 5.002V13M19.012 17.002l2 2-2 2.002M16 19.003h5.002"
  })));
};
export { SvgTagemail as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZTFkMTQzNzdmNGQ0YjA4MGQzMDA0YWNhNWQ4Zjg5Mjguc3ZnIjs=";